module.exports = __webpack_public_path__ + "img/횟집마케팅사례.7f471760.png";